import React from "react";
import { IconProps } from "./types";

interface PlusExpandIconProps extends IconProps {
  fillColor?: string;
  strokeColor?: string;
  iconColor?: string;
}

const PlusExpandIcon: React.FC<PlusExpandIconProps> = ({
  width = 16,
  height = 16,
  className,
  fillColor = "white",
  strokeColor = "#015C9A",
  iconColor = "#015C9A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 0.361328C12.2188 0.361328 15.6387 3.78116 15.6387 8C15.6387 12.2188 12.2188 15.6387 8 15.6387C3.78116 15.6387 0.361328 12.2188 0.361328 8C0.361328 3.78116 3.78116 0.361328 8 0.361328Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="0.722222"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00027 5.43262C8.17755 5.43262 8.32126 5.57633 8.32126 5.7536V7.67953H10.2472C10.4245 7.67953 10.5682 7.82324 10.5682 8.00052C10.5682 8.1778 10.4245 8.32151 10.2472 8.32151H8.32126V10.2474C8.32126 10.4247 8.17755 10.5684 8.00027 10.5684C7.823 10.5684 7.67929 10.4247 7.67929 10.2474V8.32151H5.75336C5.57608 8.32151 5.43237 8.1778 5.43237 8.00052C5.43237 7.82324 5.57608 7.67953 5.75336 7.67953H7.67929V5.7536C7.67929 5.57633 7.823 5.43262 8.00027 5.43262Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default PlusExpandIcon;
